import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5337d126"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "logo" }, " Siternet ", -1))
const _hoisted_3 = { class: "links-container" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "link-name" }

import { ref } from 'vue';
import NavDrawer from '@/components/NavDrawer.vue';
import j_links from '@/json/links.json';
import Link from '@/types/Link.type';

//* Variables.

export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const links: Link[] = j_links.links;
const showDrawer = ref<boolean>(false);

//* Functions.
const openDrawer = () => {
  showDrawer.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_fai = _resolveComponent("fai")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        class: "logo-container",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(links), (l, idx) => {
          return (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["link-container", { important: l.accent }]),
            key: idx,
            href: l.url
          }, [
            _createVNode(_component_fai, {
              class: "icon",
              icon: 'fa-solid ' + l.icon
            }, null, 8, ["icon"]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(l.name), 1)
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "bars-button-container",
        onClick: openDrawer
      }, [
        _createVNode(_component_fai, { icon: "fa-solid fa-bars" })
      ])
    ]),
    _createVNode(NavDrawer, {
      links: _unref(links),
      show: showDrawer.value,
      onCloseDrawer: _cache[0] || (_cache[0] = () => showDrawer.value = false)
    }, null, 8, ["links", "show"])
  ], 64))
}
}

})